import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="landing-footer">
      <span className="footer-copyright">
        © OMICON {new Date().getFullYear()} . All Rights Reserved    
      </span>
    </footer>
  );
};

export default Footer;
